export const loadingContainerStyles = { 
    maxWidth: '210px',
    display: 'flex',
    height: '195px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6px',
    marginTop: '1rem', 
    textAlign: "center",
};

export const spinElementStyles = {
    width: '210px',
    height: '195px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '1rem', 
    textAlign: "center",
};

export const targetChartArray = [
        {
            quarter: "Q1",
            achivementQuarter: "q1_AchPrice",
            key: 'q1'
        },
        {
            quarter: "Q2",
            achivementQuarter: "q2_AchPrice",
            key: 'q2'
        },
        {
            quarter: "Q3",
            achivementQuarter: "q3_AchPrice",
            key: 'q3'
        },
        {
            quarter: "Q4",
            achivementQuarter: "q4_AchPrice",
            key: 'q4'
        }
];

export const tableStyles = {
    components: {
        Table: {
            borderColor: "lightgrey",
            headerBg: "#da251c",
            headerColor: "white",
            cellFontSizeSM: 6,
            rowHoverBg: "#f2f2f2",
            cellPaddingBlock: 8,
            cellPaddingInlineSM: 2,
            fontSize: '13px',
            headerBorderRadius: "0px"
        },
    },
}

export const funnelBtnStyles = {
    padding: '10px',
    position: 'absolute',
    top: 6,
    left: 8,
    zIndex: 2,
    border: 'none'
}

export const funnelModalStyles = {
    width: "100%",
    minWidth: '70%',
    overflow: "auto",
    maxWidth: "90%",
}

export const funnelBoxStyles = {
    minWidth: '230px',
    minHeight: '180px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: "stretch",
    flexDirection: "column",

}

export const csvBtnVariants = {
    hidden: {
        opacity: 0,
        scale: 0,
    },
    visible: {
        scale: 1,
        opacity: 1
    }
}

export const initialFunnelFilterState = { 
    callStatusId: 0
}